import React from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";

import routes from "./routes";
import withTracker from "./withTracker";

import { LoginForm } from "./components/layout/MainSidebar/LoginForm";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";


let isAuthenticated = () => {
 const token = Number(sessionStorage.getItem("token"))
  console.log(token);
  if (token > 37  && token < 38) {
    return true
  }
  else {
    return false
  }
}

const checkAuth = (route) => {
  if (route.meta && route.meta.requiresAuth && !isAuthenticated()) {
    return (
      LoginForm
    )
  }
  else {
    return withTracker(props => {
      return (
        <route.layout {...props}>
          <route.component {...props} />
        </route.layout>
      );
    })
  }
}

export default () => (
  <Router basename={process.env.REACT_APP_BASENAME || ""}>
    <div>
      {routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={checkAuth(route)}
          />
        );
      })}
    </div>
  </Router>
);
